export class PersonMultModel {
    PersonId: number;
    FieldType: number;
    Id: number;
    // POST TO SERVER
    Main: boolean;
    Value: number;
}